import type { Hydratable } from '@vimcar/mvvm/hydratable'

import * as dataMapper from '@vimcar/mvvm/dataMapper'
import hydratable from '@vimcar/mvvm/hydratable'
import * as mobx from 'mobx'

import type { Nodes, ContentType } from '../'
import type { CustomNode } from '../CustomNode'
import type { SelectNode } from '../SelectNode'
import type { ValuedNode } from '../ValuedNode'

type AnyNode = SelectNode | ValuedNode | CustomNode

type _ComplexNode = {
  id: string
  title: string
  text: string
  subtext: string
  allowBack: boolean
  disableSearch: boolean
  _nodes: Array<{ sys: { id: string } }>
  contentModelType: ContentType
  nodes: Array<AnyNode>
}

// @ts-expect-error@2314
export type ComplexNode = Hydratable<_ComplexNode, object>

type Options = { nodes: Nodes }

const mkComplexNode = hydratable(
  ({ nodes }: Options) => {
    const complexNode = mobx.observable({
      contentModelType: 'complexNode',
      get nodes() {
        return (
          complexNode._nodes &&
          complexNode._nodes.map((o) => nodes.get(o.sys.id))
        )
      },
    } as _ComplexNode)
    return complexNode
  },
  'ComplexNode',
  {
    fields: dataMapper.lift({
      nodes: '_nodes',
    }),
    sys: dataMapper.lift({
      id: true,
    }),
  },
)

export default mkComplexNode
